import React from 'react';
import PropTypes from 'prop-types';
import { SERVICE_TYPES } from '@bagonboard/wiseman';

import getDetails from '../../../../../modules/getServiceStatusDetails';
import {
  AreaContainer,
  IconAirplane,
  IconBack,
  IconCity,
  IconTruck,
  IconWalk,
  ServiceCode,
  StatusText,
  Text,
  useHeaderStyles,
} from './style';
import { historyPropTypes } from '../../../../../types';


const {
  TRANSFER,
  CHECKIN,
  CITY_DELIVERY,
  SKIP_BAGGAGE_CLAIM,
} = SERVICE_TYPES;

function renderIcon(type) {
  switch (type) {
    case CHECKIN:
      return <IconAirplane />;
    case CITY_DELIVERY:
      return <IconCity />;
    case TRANSFER:
      return <IconTruck />;
    case SKIP_BAGGAGE_CLAIM:
      return <IconWalk />;
    default:
      return <IconTruck />;
  }
}

const Header = ({
  from, history, serviceCode, status, type,
}) => {
  const classes = useHeaderStyles();
  const details = getDetails(status);
  const onBack = () => {
    history.push('/services');
  };

  return (
    <div className={classes.root}>
      <IconBack onClick={onBack} />
      <AreaContainer>
        <Text>{from.cityCode}</Text>
        {renderIcon(type)}
      </AreaContainer>
      <ServiceCode>{serviceCode}</ServiceCode>
      <StatusText color={details.color}>{details.text}</StatusText>
    </div>
  );
};

Header.propTypes = {
  from: PropTypes.shape({
    cityCode: PropTypes.string,
  }),
  history    : historyPropTypes.isRequired,
  serviceCode: PropTypes.string,
  status     : PropTypes.string,
  type       : PropTypes.string,
};

Header.defaultProps = {
  from       : {},
  serviceCode: '',
  status     : '',
  type       : CHECKIN,
};

export default Header;
